import { Button, LinkButton } from "@simplybusiness/mobius";
import type { ButtonProps, LinkButtonProps } from "@simplybusiness/mobius";

export type LinkOrButtonProps = ButtonProps | LinkButtonProps;

export const LinkOrButton = ({
  href,
  children,
  ...rest
}: LinkOrButtonProps) => {
  if (!children) return null;

  if (href) {
    return (
      <LinkButton {...(rest as LinkButtonProps)} href={href}>
        {children}
      </LinkButton>
    );
  }

  return <Button {...(rest as ButtonProps)}>{children}</Button>;
};
